"use client";

import { useParams } from "next/navigation";
import { useEffect } from "react";

export default function HtmlLangSync() {
  const params = useParams();
  const localeParam = params?.locale;

  const locale =
    typeof localeParam === "string" ? localeParam : localeParam?.[0];

  useEffect(() => {
    if (!locale) return;

    document.documentElement.lang = locale.split("-")[0];
  }, [locale]);

  return null;
}
